// @ts-nocheck

const basketSetIsMPActive = (state, action) => {
  const { isMonopolyActive } = action.payload;

  return {
    ...state,
    isMonopolyActive,
    selectedFreebetId: isMonopolyActive ? undefined : state.selectedFreebetId,
  };
};

export default basketSetIsMPActive;
